import { render, staticRenderFns } from "./ErpGpsSendRecord.vue?vue&type=template&id=8f108b18&scoped=true&"
import script from "./ErpGpsSendRecord.vue?vue&type=script&lang=js&"
export * from "./ErpGpsSendRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f108b18",
  null
  
)

component.options.__file = "ErpGpsSendRecord.vue"
export default component.exports